"use client";

import type { ToolUIMeta, ToolUIRegistry } from "../../tool-renderer";
import { concurApprovalToolRegistry } from "./approval-registry";
import { concurApprovalWriteToolRegistry } from "./approval-write-registry";
import { concurAttendeeToolRegistry } from "./attendee-registry";
import { concurAttendeeWriteToolRegistry } from "./attendee-write-registry";
import { concurDelegateToolRegistry } from "./delegate-registry";
import { concurDelegateWriteToolRegistry } from "./delegate-write-registry";
import { concurExpenseToolRegistry } from "./expense-registry";
import { concurExpenseWriteToolRegistry } from "./expense-write-registry";
import { concurItemizationWriteToolRegistry } from "./itemization-registry";
import { concurReportToolRegistry } from "./report-registry";
import { concurReportWriteToolRegistry } from "./report-write-registry";

/** Views for the `concur` capability (expense reports, expenses, attendees). */
export const concurToolRegistry = {
  ...concurReportToolRegistry,
  ...concurApprovalToolRegistry,
  ...concurDelegateToolRegistry,
  ...concurAttendeeToolRegistry,
  ...concurExpenseToolRegistry,
  ...concurReportWriteToolRegistry,
  ...concurApprovalWriteToolRegistry,
  ...concurDelegateWriteToolRegistry,
  ...concurExpenseWriteToolRegistry,
  ...concurAttendeeWriteToolRegistry,
  ...concurItemizationWriteToolRegistry,
} satisfies ToolUIRegistry;

/**
 * Namespaced variant keyed by the progressive-disclosure inner-tool name
 * `concur_${toolName}` — without it a PD tool part falls back to the generic
 * JSON view. The bare-name entries above stay in the static tier, which
 * `AllToolNames` still requires. See ADR-057.
 */
export const concurProgressiveDisclosureToolRegistry: Record<
  string,
  ToolUIMeta
> = Object.fromEntries(
  // Widened so the empty literal `{}` still yields `[string, ToolUIMeta]`.
  Object.entries<ToolUIMeta>(concurToolRegistry).map(([name, meta]) => [
    `concur_${name}`,
    meta,
  ])
);
